import axios from 'helpers/ajax'

import { ApiError } from 'app/redux/models/errors'

/**
 * @return {Promise<Array.<Object>|ApiError>}
 */
export const getFeatures = async (params) => {
  const { clientId, token } = params ?? {}
  const config =
    clientId && token
      ? {
          params: {
            client_id: clientId,
          },
          headers: {
            'Reset-Token': token,
          },
        }
      : {}

  try {
    const { data } = await axios.get('features/', config)

    return data
  } catch (error) {
    return new ApiError(error)
  }
}
